import APIService from 'services/APIService'

const api = APIService()

export const getWhatsAppStatus = () => api.get('/me/whatsapp')

export const requestWhatsAppLinkCode = (consent = false) =>
  api.post('/me/whatsapp/link-code', { consent })

export const disconnectWhatsApp = () => api.post('/me/whatsapp/disconnect')

export const finalizeWhatsAppLink = () => api.post('/me/whatsapp/finalize')

export const downloadWhatsAppQrCode = (size = 320) =>
  api.get('/me/whatsapp/qr-code', { params: { format: 'svg', size }, responseType: 'blob' })
